import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { fn } from '@app/utils';
import { url } from '@app/utils/constants';
import { Page } from '../page';
import type { PropsWithChildren } from 'react';
import useApp from '@app/hooks/useApp';
import useMe from '@app/hooks/auth/useMe';
import useAuthActions from '@app/hooks/auth/useAuthActions';
import AuthHeader from './components/AuthHeader';

export const AuthLayout = ({ children }: PropsWithChildren) => {
    const navigate = useNavigate();
    const { notification } = useApp();
    const { logout } = useAuthActions();
    const { mutate: logoutMutate } = logout;
    // Pre-fetch the me object
    useMe();

    useEffect(() => {
        if (!fn.isLoggedIn()) {
            notification.error({
                key: 'global',
                message: 'Session Expired',
                description: 'Your session has timed out, please login again.',
            });
            navigate(url.home);
        }
    }, [navigate, notification]);

    const handleLogout = () => {
        logoutMutate(undefined, {
            onSettled: () => {
                navigate(url.home);
            },
        });
    };

    const handleLogoClick = () => {
        navigate(url.adminPortal.dashboard);
    };

    return (
        <Page onLogout={handleLogout} onLogoClick={handleLogoClick}>
            <AuthHeader onLogout={handleLogout} />
            {children ?? <Outlet />}
        </Page>
    );
};

export default AuthLayout;
